import * as React from 'react';

import { VEHICLE_STATUS } from '@klareospace/pharos-lib-types';
import type { VehicleStatus } from '@klareospace/pharos-lib-types';

import { StatusBadge } from '../status-badge/status-badge';
import { STATUS_BADGE_COLORS } from '../status-badge/status-badge-colors';

// ─── Constants ────────────────────────────────────────────────────────────────

const VEHICLE_STATUS_STYLES: Record<VehicleStatus, string> = {
  [VEHICLE_STATUS.AVAILABLE]: STATUS_BADGE_COLORS.success,
  [VEHICLE_STATUS.IN_MAINTENANCE]: STATUS_BADGE_COLORS.warning,
};

// ─── Types ────────────────────────────────────────────────────────────────────

export interface VehicleStatusBadgeProps {
  label: string;
  status: VehicleStatus;
}

// ─── Component ────────────────────────────────────────────────────────────────

/**
 * Displays a vehicle status as a coloured badge.
 * Available → green (success), In Maintenance → yellow (warning).
 */
export function VehicleStatusBadge({ label, status }: VehicleStatusBadgeProps): React.JSX.Element {
  return <StatusBadge label={label} status={status} styles={VEHICLE_STATUS_STYLES} />;
}
